import React from 'react';
import './ViewOnlyDynamicTable.css';
// import { Column } from '../dynamicTable/DynamicTable';
import ClayLayout from '@clayui/layout';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
export type Column<T> = {
    header: string;
    accessor: keyof T;
    type: 'text' | 'select' | 'searchSelect' | 'id' | 'number' | 'date' | 'boolean' | 'selectMultiple' | 'searchSelectMultiple' | 'time';
    options?: string[];
    width?: string;
    visible?: boolean;
};
// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(localizedFormat);

type DaysTableProps<T> = {
    title?: string;
    columns: Column<T>[]; // Columns with type T
    data: T[]; // Table data with type T
    onDataChange?: (updatedData: T[]) => void; // Callback to handle data updates
    readOnlyView?: boolean;
    visible?: boolean; // Optional flag to control visibility
    viewMore?: boolean;
    removePadding?: boolean;
    backgroundColor?: string;
    isPreview?: boolean;
};

const ViewOnlyDynamicTable = <T extends object>({
    title,
    columns,
    data,
    onDataChange,
    readOnlyView = false,
    viewMore = false,
    removePadding,
    backgroundColor,
    isPreview
}: DaysTableProps<T>): React.ReactElement => {

    const handleView = (row: any) => {
        const modifiedUrl = row?.href.replace('download=true', 'black');
        window.open(modifiedUrl, '_blank');
    };

    const handleAllDownloadData = () => {
        data?.map((file) => {
            handleDownload(file);
        });
    };

    const handleDownload = (data: any) => {
        const anchor = document.createElement('a');
        anchor.href = data?.href;
        anchor.download = data?.documentName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };

    const convertToFormattedDate = (
        dateString: string | null | undefined
    ): string => {
        if (!dateString) {
            return '-';
        }
        const formattedMeetingDate = dayjs
            .utc(dateString)
            .local()
            .format('DD/MM/YYYY');
        return formattedMeetingDate;
    };

    return (
        <div className='customer-dynamic-table'>
            <div className="view-dynamic-table-container" style={{ marginBottom: removePadding ? '24px' : 0 }}>
                {!readOnlyView ? (
                    <>
                        <label className="bold-heading">{title}</label>
                    </>
                ) : null}
                <table className="dynamic-table" style={{ backgroundColor: backgroundColor && 'transparent' }}>
                    <thead>
                        <tr>
                            {columns
                                .filter((column) => column.visible !== false)
                                .map((column) => (
                                    <th
                                        key={String(column.accessor)}
                                        style={{ width: column.width || 'auto', fontWeight: 700, color: title === 'uploadedFileData' ? '#2871a2' : '#1c1c24' }}
                                    >
                                        {column.header}
                                    </th>
                                ))}
                            {!isPreview && title === 'uploadedFileData' && (
                                <>
                                    <th style={{ width: '5%' }}></th>
                                    <th
                                        style={{
                                            width: '5%',
                                            padding: '0 16px important!',
                                            cursor: 'pointer',
                                            textAlign: 'center'
                                        }}
                                        onClick={handleAllDownloadData}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="4 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M6.58317 19.5C6.46484 19.5 6.36595 19.46 6.2865 19.38C6.2065 19.3 6.1665 19.2011 6.1665 19.0833C6.1665 18.9656 6.2065 18.8667 6.2865 18.7867C6.3665 18.7067 6.46539 18.6667 6.58317 18.6667H17.4165C17.5348 18.6667 17.6337 18.7067 17.7132 18.7867C17.7926 18.8667 17.8326 18.9656 17.8332 19.0833C17.8332 19.2011 17.7932 19.3 17.7132 19.38C17.6337 19.4594 17.5348 19.4992 17.4165 19.4992L6.58317 19.5ZM11.9832 15.9183C11.8832 15.9183 11.7851 15.8961 11.689 15.8517C11.594 15.8061 11.5129 15.7386 11.4457 15.6492L8.1215 11.2392C7.95595 11.0147 7.93456 10.7783 8.05734 10.53C8.18012 10.2811 8.38095 10.1567 8.65984 10.1567H10.029V5.17333C10.029 4.98222 10.0934 4.82222 10.2223 4.69333C10.3512 4.56444 10.5109 4.5 10.7015 4.5H13.2815C13.4726 4.5 13.6326 4.56444 13.7615 4.69333C13.8904 4.82222 13.9548 4.98222 13.9548 5.17333V10.1567H15.3232C15.6026 10.1567 15.8037 10.2811 15.9265 10.53C16.0487 10.7783 16.0273 11.0144 15.8623 11.2383L12.5223 15.6492C12.4551 15.7386 12.3737 15.8058 12.2782 15.8508C12.1832 15.8953 12.0851 15.9175 11.984 15.9175M11.984 14.9967L14.9615 11.0067H13.1215V5.33333H10.8623V11.0067H9.02234L11.984 14.9967Z"
                                                fill="#003764"
                                            />
                                        </svg>
                                    </th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {columns
                                    .filter((column) => column.visible !== false)
                                    .map((column) => {
                                        const rawValue = String(row[column.accessor] ?? '');
                                        const formattedValue = convertToFormattedDate(rawValue);

                                        return (
                                            <td
                                                key={String(column.accessor)}
                                                className="table-cell"
                                                style={{ width: column.width || 'auto', fontWeight: column?.accessor === "role" ? 700 : 400 }}
                                            >
                                                {column?.accessor === "documentName" ? (
                                                    <span style={{ backgroundColor: "#D4F3FA", padding: "10px", borderRadius: "8px" }}>
                                                        {rawValue}
                                                    </span>
                                                ) : (
                                                    <span style={{ fontWeight: column?.accessor === "role" ? 700 : 400 }}>{rawValue}</span>
                                                )}
                                            </td>

                                        );
                                    })}

                                {!isPreview && title === 'uploadedFileData' && (
                                    <>
                                        <td
                                            style={{
                                                width: '5%',
                                                padding: '0 16px important!',
                                                cursor: 'pointer',
                                                textAlign: 'center'
                                            }}
                                            onClick={() => handleView(row)}
                                        >
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="1 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M10.0043 12.6296C10.851 12.6296 11.5693 12.3332 12.1593 11.7405C12.7493 11.1477 13.0446 10.4277 13.0452 9.58047C13.0452 8.7338 12.7488 8.01547 12.156 7.42547C11.5632 6.83547 10.8432 6.54019 9.996 6.53964C9.14934 6.53964 8.431 6.83602 7.841 7.4288C7.251 8.02158 6.95572 8.74158 6.95517 9.5888C6.95517 10.4355 7.25156 11.1538 7.84434 11.7438C8.43711 12.3338 9.15711 12.6291 10.0043 12.6296ZM10.0002 11.8346C9.37517 11.8346 8.84406 11.616 8.40684 11.1788C7.96961 10.7416 7.75073 10.2102 7.75017 9.58464C7.75017 8.95964 7.96906 8.42852 8.40684 7.9913C8.84461 7.55408 9.37573 7.33519 10.0002 7.33464C10.6252 7.33464 11.1566 7.55352 11.5943 7.9913C12.0321 8.42908 12.2507 8.96019 12.2502 9.58464C12.2502 10.2096 12.0316 10.741 11.5943 11.1788C11.1571 11.6166 10.6257 11.8352 10.0002 11.8346ZM10.0002 15.0013C8.35295 15.0013 6.84184 14.5652 5.46684 13.693C4.09184 12.8207 2.98156 11.6777 2.136 10.2638C2.06656 10.1499 2.01739 10.0374 1.9885 9.9263C1.95906 9.81519 1.94434 9.70102 1.94434 9.5838C1.94434 9.46714 1.95906 9.35325 1.9885 9.24214C2.01739 9.13158 2.06656 9.01936 2.136 8.90547C2.98267 7.49047 4.09322 6.34714 5.46767 5.47547C6.84211 4.6038 8.35295 4.16797 10.0002 4.16797C11.6474 4.16797 13.1585 4.60408 14.5335 5.4763C15.9074 6.34741 17.0177 7.49047 17.8643 8.90547C17.9338 9.01936 17.9829 9.13186 18.0118 9.24297C18.0413 9.35408 18.056 9.46825 18.056 9.58547C18.056 9.70214 18.0413 9.81602 18.0118 9.92714C17.9829 10.0377 17.9338 10.1499 17.8643 10.2638C17.0177 11.6788 15.9071 12.8221 14.5327 13.6938C13.1582 14.5655 11.6474 15.0013 10.0002 15.0013ZM10.0002 14.168C11.5696 14.168 13.0107 13.7549 14.3235 12.9288C15.6363 12.1027 16.6396 10.988 17.3335 9.58464C16.6391 8.18186 15.6354 7.06741 14.3227 6.2413C13.0099 5.41519 11.5691 5.00186 10.0002 5.0013C8.43073 5.0013 6.98989 5.41464 5.67767 6.2413C4.36545 7.06797 3.36184 8.18241 2.66684 9.58464C3.36128 10.9874 4.36489 12.1021 5.67767 12.9288C6.99045 13.7555 8.43128 14.1685 10.0002 14.168Z"
                                                    fill="#003764"
                                                />
                                            </svg>
                                        </td>
                                        <td
                                            style={{
                                                width: '5%',
                                                padding: '0 16px important!',
                                                cursor: 'pointer',
                                                textAlign: 'center'
                                            }}
                                            onClick={() => handleDownload(row)}
                                        >
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="4 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.58317 19.5C6.46484 19.5 6.36595 19.46 6.2865 19.38C6.2065 19.3 6.1665 19.2011 6.1665 19.0833C6.1665 18.9656 6.2065 18.8667 6.2865 18.7867C6.3665 18.7067 6.46539 18.6667 6.58317 18.6667H17.4165C17.5348 18.6667 17.6337 18.7067 17.7132 18.7867C17.7926 18.8667 17.8326 18.9656 17.8332 19.0833C17.8332 19.2011 17.7932 19.3 17.7132 19.38C17.6337 19.4594 17.5348 19.4992 17.4165 19.4992L6.58317 19.5ZM11.9832 15.9183C11.8832 15.9183 11.7851 15.8961 11.689 15.8517C11.594 15.8061 11.5129 15.7386 11.4457 15.6492L8.1215 11.2392C7.95595 11.0147 7.93456 10.7783 8.05734 10.53C8.18012 10.2811 8.38095 10.1567 8.65984 10.1567H10.029V5.17333C10.029 4.98222 10.0934 4.82222 10.2223 4.69333C10.3512 4.56444 10.5109 4.5 10.7015 4.5H13.2815C13.4726 4.5 13.6326 4.56444 13.7615 4.69333C13.8904 4.82222 13.9548 4.98222 13.9548 5.17333V10.1567H15.3232C15.6026 10.1567 15.8037 10.2811 15.9265 10.53C16.0487 10.7783 16.0273 11.0144 15.8623 11.2383L12.5223 15.6492C12.4551 15.7386 12.3737 15.8058 12.2782 15.8508C12.1832 15.8953 12.0851 15.9175 11.984 15.9175M11.984 14.9967L14.9615 11.0067H13.1215V5.33333H10.8623V11.0067H9.02234L11.984 14.9967Z"
                                                    fill="#003764"
                                                />
                                            </svg>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
                {readOnlyView && viewMore ? (
                    <>
                        <ClayLayout.ContentSection className="button-container mt-2">
                            <a className="view-more-btn">View More</a>
                        </ClayLayout.ContentSection>
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default ViewOnlyDynamicTable;
